<div class="container row gy-6">

    <div class="col-lg-4">
        <h2 class="display-2 mt-lg-18 mb-3">{{plansData.pricing.title}}</h2>
        <p class="lead fs-lg mb-3" [innerHTML]="plansData.pricing.description"></p>
        <a href="#" class="btn btn-primary rounded-xl mt-2">See All Prices</a>
    </div>
    <!--/column -->
    <div class="col-lg-7 offset-lg-1 pricing-wrapper">
        <div class="pricing-switcher-wrapper switcher justify-content-start justify-content-lg-end">
        <p class="mb-0 pe-3">Monthly</p>
        <div class="pricing-switchers">
            <div class="pricing-switcher pricing-switcher-active"></div>
            <div class="pricing-switcher"></div>
            <div class="switcher-button bg-primary"></div>
        </div>
        <p class="mb-0 ps-3">Yearly <span class="text-fuchsia">(Save 30%)</span></p>
        </div>
        <div class="row gy-6 position-relative mt-5">
        <div class="col-md-6">
            <div class="position-absolute pe-none d-none d-md-block" style="top: 55%; left: 50%; width: 140%; height: auto; transform: translate(-50%,-50%); z-index:-1"><img class="w-100" alt="blurryImg"></div>
            <div class="pricing card shadow-xl rounded-xl">
            <div class="card-body pb-12">
                <div class="prices text-dark">
                <div class="price price-show justify-content-start"><span class="price-currency">$</span><span class="price-value">19</span> <span class="price-duration">mo</span></div>
                <div class="price price-hide price-hidden justify-content-start"><span class="price-currency">$</span><span class="price-value">199</span> <span class="price-duration">yr</span></div>
                </div>
                <!--/.prices -->
                <h4 class="card-title mt-2">Premium Plan</h4>
                <ul class="icon-list bullet-primary mt-7 mb-8">
                <li><i class="uil uil-check fs-21"></i><span><strong>5</strong> Projects </span></li>
                <li><i class="uil uil-check fs-21"></i><span><strong>100K</strong> API Access </span></li>
                <li><i class="uil uil-check fs-21"></i><span><strong>200MB</strong> Storage </span></li>
                <li><i class="uil uil-check fs-21"></i><span> Weekly <strong>Reports</strong></span></li>
                <li><i class="uil uil-check fs-21"></i><span> 7/24 <strong>Support</strong></span></li>
                </ul>
                <a href="#" class="btn btn-primary rounded-xl">Choose Plan</a>
            </div>
            <!--/.card-body -->
            </div>
            <!--/.pricing -->
        </div>
        <!--/column -->
        <div class="col-md-6 popular">
            <div class="pricing card shadow-xl rounded-xl">
            <div class="card-body pb-12">
                <div class="prices text-dark">
                <div class="price price-show justify-content-start"><span class="price-currency">$</span><span class="price-value">49</span> <span class="price-duration">mo</span></div>
                <div class="price price-hide price-hidden justify-content-start"><span class="price-currency">$</span><span class="price-value">499</span> <span class="price-duration">yr</span></div>
                </div>
                <!--/.prices -->
                <h4 class="card-title mt-2">Corporate Plan</h4>
                <ul class="icon-list bullet-primary mt-7 mb-8">
                <li><i class="uil uil-check fs-21"></i><span><strong>20</strong> Projects </span></li>
                <li><i class="uil uil-check fs-21"></i><span><strong>300K</strong> API Access </span></li>
                <li><i class="uil uil-check fs-21"></i><span><strong>500MB</strong> Storage </span></li>
                <li><i class="uil uil-check fs-21"></i><span> Weekly <strong>Reports</strong></span></li>
                <li><i class="uil uil-check fs-21"></i><span> 7/24 <strong>Support</strong></span></li>
                </ul>
                <a href="#" class="btn btn-primary rounded-xl">Choose Plan</a>
            </div>
            <!--/.card-body -->
            </div>
            <!--/.pricing -->
        </div>
        <!--/column -->
        </div>
        <!--/.row -->
    </div>
</div>
